/**
 * La barra de avance.
 *
 * ⚠ **El número va escrito al lado, siempre.** El ancho de la barra no puede ser el
 * único portador del dato (WCAG 1.4.1): un 68 % y un 72 % son la misma barra a
 * simple vista, y en una impresión en blanco y negro el color desaparece del todo.
 *
 * ⚠ **No se anima.** Esta pantalla se refresca al tocar cualquier etapa, y una barra
 * que corre en cada refresco convierte marcar tres hitos seguidos en un temblor. Es
 * la misma razón por la que no se anima una fila de tabla al recargar datos.
 */

export function Barra({ porcentaje }: { porcentaje: number }) {
  const valor = Math.max(0, Math.min(100, Math.round(porcentaje)))
  const tono =
    valor >= 100 ? "var(--success)" : valor > 0 ? "var(--primary-texto)" : "var(--border)"

  return (
    <div className="flex items-center gap-3">
      <div
        role="progressbar"
        aria-valuenow={valor}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Avance"
        className="h-2 flex-1 overflow-hidden rounded-full"
        style={{ backgroundColor: "var(--surface-elevated)" }}
      >
        <div className="h-full" style={{ width: `${valor}%`, backgroundColor: tono }} />
      </div>
      <span className="w-12 text-right text-sm font-semibold tabular">{valor} %</span>
    </div>
  )
}
